import { createContext } from 'react';
import { isVisActorOuterDomain } from './http';
import { isValid } from '@visactor/vutils';

export enum LanguageEnum {
  chinese = 'zh',
  english = 'en',
}

/** SSR-safe: same result on server and client (no localStorage/navigator). Use for initial render to avoid hydration mismatch. */
export const getInitialLanguage = (hostname: string): LanguageEnum => {
  return isVisActorOuterDomain(hostname)
    ? LanguageEnum.english
    : LanguageEnum.chinese;
};

export const getStoredLanguage = (hostname: string): LanguageEnum => {
  let defaultLanguage = getInitialLanguage(hostname);

  if (typeof document === 'undefined') {
    return defaultLanguage;
  }
  defaultLanguage = window.navigator.language.startsWith('zh')
    ? LanguageEnum.chinese
    : LanguageEnum.english;
  const storedLanguage = window.localStorage.getItem('language');
  // compatible language
  return storedLanguage === '1'
    ? LanguageEnum.chinese
    : storedLanguage === '2'
    ? LanguageEnum.english
    : isValid(storedLanguage)
    ? (storedLanguage as LanguageEnum)
    : defaultLanguage;
};

export const storeLanguage = (language: LanguageEnum) => {
  window.localStorage.setItem('language', `${language}`);
};

export const LanguageContext = createContext({
  language: LanguageEnum.chinese,
  setLanguage: (language: LanguageEnum) => {},
  isVisActorChineseDomain: true,
  isVisActorInnerDomain: false,
  isMobile: false,
});
